import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { projectDetails } from '../../../../../../../core/projects.selectors';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, map } from 'rxjs/operators';
import { linkedCountText, linkedRecordCount } from '../../../../../../../../../shared/helpers/design-context';

@Component({
    selector: 'app-material-delivery-and-usage-summary',
    templateUrl: './material-delivery-and-usage-summary.component.html',
    styleUrls: ['./material-delivery-and-usage-summary.component.scss'],
    standalone: false
})
export class MaterialDeliveryAndUsageSummaryComponent implements OnInit, OnDestroy {
  /** Lets a superseded link's badge add "· map now rev M" on the read-only card. */
  readonly projectId$ = inject(Store).select(projectDetails).pipe(map(project => project?.id ?? null));
  @Input() data: any;
  readonly linkedCountText = linkedCountText;
  /** A bid item with materials groups one delivery line per material. Usage rows are not link entities. */
  get linkedMaterialCount(): number {
    return this.data?.type === 'delivery' ? linkedRecordCount(this.data?.materials) : 0;
  }
  matchedId: any;
  matchedNo: any;
  widgetIds: any = [];
  displayMatched: boolean;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp && qp['matchedId']) {
          this.matchedId = qp['matchedId'];

          if (!Array.isArray(this.matchedId)) {
            this.matchedId = [this.matchedId];
          }

          if (this.matchedId?.length) {
            this.matchedId?.forEach((item) => {
              this.widgetIds?.push(item?.split('_')?.[1]);
            });
          }

          const tempData = this.matchedId?.filter((item) => {
            const parts = item?.split('_');
            return parts?.length === 3 && parts[1] === this.data?.id;
          });
          this.matchedNo = tempData[0]?.split('_')?.[2];
        }

        this.setDisplayMatched();
      });
  }

  setDisplayMatched() {
    if (this.data?.id && this.widgetIds?.length) {
      if (this.widgetIds?.includes(this.data?.id)) {
        this.displayMatched = true;
      }
    }

    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
